import { Injectable } from '@angular/core';
import { CodigoRegistroDaService } from './codigo-registro-da.service';
import { CodigoRegistro } from '../models/codigo-registro';

@Injectable({
  providedIn: 'root'
})
export class CodigoRegistroBlService {

  constructor(
    private codigoRegistroDA: CodigoRegistroDaService
  ) { }

  insertCodigo(codigo:CodigoRegistro){
    return this.codigoRegistroDA.insertCodigo(codigo);
  }
  getCodigoLectura(codigo:number, correoElectronico:string){
    return this.codigoRegistroDA.getCodigoLectura(codigo, correoElectronico);
  }
  updateValidezCodigo(idDocumento:string){
    return this.codigoRegistroDA.updateValidezCodigo(idDocumento);
  }
}
